import { Injectable, Inject } from '@angular/core';
import { APP_SETTINGS, IAppSettings } from '@indice/ng-config';

@Injectable({
    providedIn: 'root'
})
export class LoggerService {
    constructor(@Inject(APP_SETTINGS) private appSettings: IAppSettings) { }

    public log(message: any, ...params: any[]): void {
        if (!this.appSettings.production) {
            params ? console.log(message, params) : console.log(message);
        }
    }

    public info(message: any, ...params: any[]): void {
        if (!this.appSettings.production) {
            params ? console.info(message, params) : console.info(message);
        }
    }

    public warn(message: any, ...params: any[]): void {
        if (!this.appSettings.production) {
            params ? console.warn(message, params) : console.warn(message);
        }
    }

    public error(message: any, ...params: any[]): void {
        if (!this.appSettings.production) {
            params ? console.error(message, params) : console.error(message);
        }
    }
}
